import { UserCircleIcon, UserIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';

function ActiveUsers({ users, orientation = "vertical" }) {
  const [sortedUsers, setSortedUsers] = useState([]);
  const isHorizontal = orientation === "horizontal";

  // Sort users by name when users prop changes
  useEffect(() => {
    if (!users || !Array.isArray(users)) return;
    
    const sorted = [...users].sort((a, b) => 
      a.username.localeCompare(b.username));
    setSortedUsers(sorted);
  }, [users]);

  if (!users || users.length === 0) {
    return (
      <div className={`flex ${isHorizontal ? 'flex-row flex-wrap justify-center' : 'flex-col'} p-4`}>
        <div className="text-gray-400 text-sm">
          No users online
        </div>
      </div>
    );
  }

  return (
    <div className={`${isHorizontal ? 'flex flex-row flex-wrap items-center gap-2' : 'flex-col'}`}>
      {/* Header - only for vertical layout */}
      {!isHorizontal && (
        <div className="sticky top-0 bg-gray-900 p-4 border-b border-gray-700 z-10">
          <h3 className="text-gray-200 font-medium flex items-center gap-2">
            <UserIcon className="h-5 w-5 text-blue-400" />
            <span>Online Users ({sortedUsers.length})</span>
          </h3>
        </div>
      )}
      
      {isHorizontal ? (
        // Horizontal layout for top of chat
        <div className="flex flex-row flex-wrap gap-2 p-2">
          {sortedUsers.map((user) => (
            <div 
              key={user.username} 
              className="flex items-center bg-gray-800 rounded-full px-3 py-1 border border-gray-700 hover:bg-gray-700 transition-colors"
              title={`${user.username} - Last active: ${new Date(user.lastActive).toLocaleTimeString()}`}
            >
              <div className="relative">
                <UserCircleIcon className="h-4 w-4 text-indigo-400 mr-1.5" />
                <span className="absolute bottom-0 right-0 h-1.5 w-1.5 rounded-full bg-green-400 ring-1 ring-gray-800"></span>
              </div>
              <span className="text-xs font-medium text-gray-200 truncate max-w-[100px]">
                {user.username}
              </span>
            </div>
          ))}
        </div>
      ) : (
        // Vertical layout for sidebar
        <ul className="p-3 space-y-2 overflow-y-auto max-h-[calc(100vh-120px)]">
          {sortedUsers.map((user) => (
            <li 
              key={user.username}
              className="flex items-center p-3 bg-gray-800 rounded-lg border border-gray-700 hover:bg-gray-750 transition-colors"
            >
              <div className="relative flex-shrink-0">
                <div className="p-1.5 bg-gray-700 rounded-full">
                  <UserCircleIcon className="h-6 w-6 text-indigo-400" />
                </div>
                <span className="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full bg-green-400 ring-1 ring-gray-800"></span>
              </div>
              <div className="ml-3 overflow-hidden">
                <p className="text-sm font-medium text-gray-200 truncate">
                  {user.username}
                </p>
                <p className="text-xs text-gray-400 truncate">
                  Active {new Date(user.lastActive).toLocaleTimeString()}
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ActiveUsers; 